"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilePresentation = void 0;
/**
 *The FilePresentation model includes information about the presented file, such as the file [ID](#id), information about the[participant who presents the file](#owner), [number of images within the shared file](#optional-imagecount), and the [current position](#optional-position) that informs which image is currently presented.
 */
class FilePresentation {
    /** @ignore */
    constructor(id) {
        /**
         * The number of the currently displayed image of the shared file.
         */
        this.position = 0;
        this.id = id;
    }
}
exports.FilePresentation = FilePresentation;
